export const judgeIE = () => {
  const browser = window.navigator.userAgent.toLowerCase();
  const html = document.documentElement;

  if (browser.indexOf('msie') > 0 || browser.indexOf('trident') > 0) {
    html.classList.add('ua-ie');

    document.body.addEventListener('mousewheel', (event) => {
      event.preventDefault();
      const wd = event.wheelDelta;
      const csp = window.pageYOffset;
      window.scrollTo(0, csp - wd);
    });

    return true;
  }

  return false;
};
